export const firebaseConfig = {
    apiKey: "AIzaSyALJ8t73yvGeweDCZoY0fvGN2bmwWkVSys",
    authDomain: "voting-8b9ca.firebaseapp.com",
    databaseURL: "https://voting-8b9ca-default-rtdb.firebaseio.com",
    projectId: "voting-8b9ca",
    storageBucket: "voting-8b9ca.appspot.com",
    messagingSenderId: "293660194715",
    appId: "1:293660194715:web:00bf4560f6b765b62d933e"
  };